import { render } from "./ReportIndex.vue?vue&type=template&id=20c14384&scoped=true&ts=true"
import script from "./ReportIndex.vue?vue&type=script&lang=ts"
export * from "./ReportIndex.vue?vue&type=script&lang=ts"

import "./ReportIndex.vue?vue&type=style&index=0&id=20c14384&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c14384"]])

export default __exports__